import React from 'react';
import { ServerAddress,  } from "./urls";


import Cookies from 'universal-cookie';




const RefreshToken = async () => {
    const cookies = new Cookies();
    let headers = new Headers();
    const cookieRefreshToken = await cookies.get('refreshToken')
    let formData = new FormData();
    formData.append('refresh-token', cookieRefreshToken);
   
    const param = formData
   
    // headers.append("Content-Type", 'multipart/form-data')
    return new Promise((resolve, reject) => {
        fetch(ServerAddress + "basic-authentication/refresh-token", {
            method: "POST",
            headers: headers,
            body: param
        }).then((response) => {
            return response.json().then(function (data) {
                if (data?.hasOwnProperty("accessToken")) {
                    resolve(data)
                }
                else {
                   reject(data)
                }
            })
        }).catch((error) => {
           
          reject()
        })
    })
}

export default RefreshToken
